
if (wishlistJs) {
  cartPage();
}
else {
  console.log("Cart page script is not triggered");
}
function cartPage() {
  const wishlistCartJs = document.getElementById('wishlistcartscript');
  let parsedWishlistCartJs = JSON.parse(wishlistCartJs.textContent);
  const moveToWishlistText = parsedWishlistCartJs.moveText;
  const addedToWishlistText = parsedWishlistCartJs.moveToWishlistSuccessText;
  const customMoveToWishlistElement = document.getElementById('moveToWishlistIcon');
  let customMoveToWishlist = '';
  var removeTrigger = false;
  if (customMoveToWishlistElement) {
    customMoveToWishlist = customMoveToWishlistElement.innerHTML;
  }
  /* Graphql to get product ID */
  async function queryProductIdFunction(product, vtnEndpoint, vtnStorefrontAccessToken, vtnCache) {
    const query = `query getProductId{
                    productByHandle(handle: "${product}") {
                        id
                    }
            }`;

    try {
      const result = await fetch(vtnEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': vtnStorefrontAccessToken,
        },
        body: JSON.stringify({
          ...(query && { query }),
        }),
        vtnCache,
      });
      const body = await result.json();
      return body.data;
    } catch (e) {
      console.log(e.message);
    }
  }

  // create and append save to wishlist buttons
  function addMoveToWishlistButton(i, variantId, productHandle, productId = "") {
    let heartIcon = `<svg class="icon icon-heart" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <path d="M340.8,98.4c50.7,0,91.9,41.3,91.9,92.3c0,26.2-10.9,49.8-28.3,66.6L256,407.1L105,254.6c-15.8-16.6-25.6-39.1-25.6-63.9  c0-51,41.1-92.3,91.9-92.3c38.2,0,70.9,23.4,84.8,56.8C269.8,121.9,302.6,98.4,340.8,98.4 M340.8,83C307,83,276,98.8,256,124.8  c-20-26-51-41.8-84.8-41.8C112.1,83,64,131.3,64,190.7c0,27.9,10.6,54.4,29.9,74.6L245.1,418l10.9,11l10.9-11l148.3-149.8  c21-20.3,32.8-47.9,32.8-77.5C448,131.3,399.9,83,340.8,83L340.8,83z"/>
    </svg>`;
    let moveToWishlistButton = document.createElement('w-cart-button');
    moveToWishlistButton.className = 'save-to-wishlist';
    moveToWishlistButton.setAttribute('data-product', productId);
    moveToWishlistButton.setAttribute('data-variant', variantId);
    moveToWishlistButton.setAttribute('data-product-url', productHandle);
    moveToWishlistButton.innerHTML = `<span>${customMoveToWishlist != '' ? customMoveToWishlist : heartIcon}</span> ${moveToWishlistText}`;
    return moveToWishlistButton;
  }

  window.vtMoveToWishlistFromCartInit = cartItemsLoop;
  function cartItemsLoop() {
    let cartItems;
    const wishlistCartTarget = document.querySelectorAll('.vt-wishlist-custom-cart');

    if (wishlistCartTarget.length > 0) {
      cartItems = wishlistCartTarget;
    } else {
      cartItems = document.querySelectorAll('.cart-item');
    }

    cartItems.forEach(function (item) {
      let variantId, productHandle, productId, moveToWishlistButton;
      if (wishlistCartTarget.length > 0) {
        variantId = item.getAttribute('data-variant-id');
        productHandle = item.getAttribute('data-product-handle');
        productId = item.getAttribute('data-product-id');
        moveToWishlistButton = addMoveToWishlistButton(item, variantId, productHandle, productId);
        if (!item.parentNode.querySelector('w-cart-button')) {
          item.appendChild(moveToWishlistButton);
        }
      }
      else {
        let productDetailedHandle = item.querySelector('.cart-item__details').querySelector('a').getAttribute('href').split('/products/')[1];
        productHandle = productDetailedHandle.split('?variant=')[0];
        variantId = productDetailedHandle.split('?variant=')[1];
        item = item.querySelector('.discounts');
        moveToWishlistButton = addMoveToWishlistButton(item, variantId, productHandle, productId);
        if (!item.nextElementSibling || !item.nextElementSibling.tagName === 'W-CART-BUTTON') {
          wishlistInsertAfter(moveToWishlistButton, item);
        }
      }
    });
    saveToWishlist(wishlistCartTarget);

  }

  function showAddedToWishlistCartNotification(){
    let addedToWishlistHtml = document.createElement('div');
    addedToWishlistHtml.className = 'fixed-wishlist-notification';
    addedToWishlistHtml.innerHTML = `<div class="fixed-wishlist-notification-inner">${addedToWishlistText}</div>`;
    document.querySelector('body').appendChild(addedToWishlistHtml);

    if(addedToWishlistText.indexOf('[') > -1 ){
      let firstText = addedToWishlistText.split('[')[0];
      let middleText = addedToWishlistText.split('[')[1].split(']')[0];
      let lastText = addedToWishlistText.split(']')[1];
      let finalAddedToWishlistText =  `${firstText}<a href="${wishlistPageUrl}">${middleText}</a>${lastText}`;
      document.querySelector('.fixed-wishlist-notification-inner').innerHTML = finalAddedToWishlistText;
    }
}
showAddedToWishlistCartNotification();

  function saveToWishlist(wishlistCartTarget) {
    let savetoWishlistButtons = document.querySelectorAll('.save-to-wishlist');
    savetoWishlistButtons.forEach(function (savetoWishlistButton) {
      savetoWishlistButton.addEventListener('click', async function (e) {
        e.preventDefault();
        if (wishlistCartTarget.length === 0) {
          let productId;
          let productHandle = e.currentTarget.getAttribute('data-product-url');
          if( (e.currentTarget.hasAttribute('data-product')) && (e.currentTarget.getAttribute('data-product') !== '') ){
            productId = e.currentTarget.getAttribute('data-product');
          }else{
          let productIdData = await queryProductIdFunction(productHandle, vtnEndpoint, vtnStorefrontAccessToken, vtnCache);
            productId = productIdData.productByHandle.id.split('/Product/')[1];
            savetoWishlistButton.setAttribute('data-product', productId);
          }
        }
        addToWishlistAndRemove(e.target);
        removeFromCart(e.target);
        removeTrigger = true;
        document.addEventListener('vtWishlistCartChange', function (event) {
          if(removeTrigger){
            let cartNotificationElement = document.querySelector('.fixed-wishlist-notification');
            if(cartNotificationElement){
              cartNotificationElement.style.right = '0';
              let cartTimeoutId = setTimeout(function () {
                cartNotificationElement.style.right = '-100%';
              }, 5500);
    
              // Event listener for mouseover
              cartNotificationElement.addEventListener("mouseover", function () {
                clearTimeout(cartTimeoutId);
              });
    
              // Event listener for mouseout
              cartNotificationElement.addEventListener("mouseout", function () {
                cartTimeoutId = setTimeout(function () {
                  cartNotificationElement.style.right = '-100%';
                }, 500);
              });
            }
            removeTrigger = false;
         }
        })

      });
    })
  }

  function addToWishlistAndRemove(target) {
    let toBeAdded = true;
    let wishlistData;
    let product = {
      wpdi: target.dataset.product,
      wpdvi: target.dataset.variant,
      wpdurl: target.dataset.productUrl,
      source: window.location.pathname
    }
    if (localStorage.getItem("wishlist") === null) {
      wishlistData = [];
    } else {
      wishlistData = JSON.parse(localStorage.getItem("wishlist"));
      wishlistData.some(element => { if (element.wpdvi === product.wpdvi) { toBeAdded = false } })
    }
    if (toBeAdded) {
      wishlistData.push(product);
      localStorage.setItem('wishlist', JSON.stringify(wishlistData));
      sendData(wishlistData);
      updateCount();
      dispatchvtWishCustomEvent('eventVtAddToWishlist', {
        wpdi: product.wpdi,
        wpdvi: product.wpdvi,
        targetFrom: 'cart'
      });
    }
  }

  function removeFromCart(target) {

    const wishlistCartItemTarget = document.querySelectorAll('.vt-wishlist-custom-cart-item');
    if (wishlistCartItemTarget.length > 0) {
   target.closest('.vt-wishlist-custom-cart-item').querySelector('.cart-item__remove').click();
    //  wishlistCartRemoveTarget
    } else {
      if(target.closest('.cart-item').querySelector('cart-remove-button')){
        target.closest('.cart-item').querySelector('cart-remove-button').dispatchEvent(new Event('click'));
      }
    }
    
  }

  // listen api requests & reInit the functions
  const constantMock = window.fetch;
  window.fetch = function () {
    return new Promise((resolve, reject) => {
      constantMock
        .apply(this, arguments)
        .then((response) => {
          if (((response.url.indexOf("/cart/change") > -1) || (response.url.indexOf("/cart/add") > -1)) && response.type != "cors") {
            if (response.url.indexOf("/cart/change") > -1) {
              dispatchvtWishCustomEvent('vtWishlistCartChange');
            }
            setTimeout(function () {
              cartItemsLoop();
            }, 1000)
          }
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
    });
  }



  /* For side cart */
  const cartLinkElement = document.querySelector('#cart-icon-bubble');
  if(cartLinkElement){
    cartLinkElement.addEventListener('click', (event) => {
      setTimeout(function () {
        cartItemsLoop();
      }, 1200)
    });
  }

  cartItemsLoop();

}